module.exports = __webpack_public_path__ + "BootstrapPostit.svg?f7009a5fe207e90e1fb53b1cffa3ec3c";